<template>
  <OPanelLink
    :path="`/order/${data.idOrder}`"
  >
    <AttachmentEmbedContainer
      :path="`/order/${data.idOrder}`"
      :title="`# ${data.orderNumber}`"
      :info="`${data.priceLabel}`"
      type="Sale"
      icon="sale"
    />
  </OPanelLink>
</template>

<script setup lang="ts">
import AttachmentEmbedContainer from '../../embed/Container.vue'

import { Order } from '~/_api/models/order'

interface Props {
  attachment: Record<string, any>
}

const props = defineProps<Props>()

const data = computed(() => new Order(props.attachment.object))
</script>
